import { forwardRef } from "react";

import { isNil } from "lodash";

import { MaskedInput } from "./masked-input";
import { type TextInputProps } from "./text-input";

interface SuffixedInputProps extends TextInputProps {
  readonly min?: number;
  readonly max?: number;
  readonly decimal?: boolean;
  readonly suffix: string;
}

export const SuffixedInput = forwardRef<HTMLInputElement, SuffixedInputProps>(
  (props, ref) => {
    const stripSymbol = (val: string) => val.replace(/[^\d\.]/, "");

    return (
      <MaskedInput
        {...props}
        maskOptions={{
          mask: `num ${props.suffix}`,
          blocks: {
            num: {
              mask: Number,
              radix: ".",
              mapToRadix: ["."],
              thousandsSeparator: ",",
              normalizeZeros: true,
              scale: props.decimal ? 2 : 0,
              min: props.min,
              max: props.max,
            },
            validate: (v: string) => {
              if (v === null) {
                return true;
              }
              const parsed = parseFloat(stripSymbol(v));
              if (parsed !== null) {
                return true;
              }
              return false;
            },
          },
        }}
        value={
          !isNil(props.value) ? `${props.value} ${props.suffix}` : undefined
        }
        validator={(v: string | null | undefined) => {
          if (v === null || v === undefined || v === "") {
            return true;
          }
          const value = Number(stripSymbol(v));
          if (props.min !== undefined && value < props.min) {
            return false;
          }
          return true;
        }}
        ref={ref}
      />
    );
  },
);
